import Store from '@/redux';
import Application from '@/App';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { GlobalStyles, Theme } from '@/theme';

import { init as Sentry } from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { BrowserTracing } from '@sentry/tracing';
import { ThemeProvider } from 'styled-components';
import { sentryDNS, reCAPTCHA } from '@/utils/API';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { isStaging } from './utils/Location';

import.meta.env.PROD &&
  !!sentryDNS &&
  Sentry({
    tracesSampleRate: +import.meta.env.VITE_SENTRY_SAMPLE_RATE ?? 0.0,
    integrations: [new BrowserTracing()],
    dsn: sentryDNS,

    ignoreErrors: [
      'Non-Error promise rejection captured',
      'McD Bridge already initialized',
      'Non-Error exception captured'
    ]
  });

const ApplicationWrapper = (
  <Provider store={Store}>
    <ThemeProvider theme={Theme}>
      <GlobalStyles />

      <BrowserRouter>
        <Application />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);

createRoot(document.getElementById('root') as HTMLElement).render(
  reCAPTCHA ? (
    <GoogleReCaptchaProvider reCaptchaKey={reCAPTCHA} useEnterprise>
      {ApplicationWrapper}
    </GoogleReCaptchaProvider>
  ) : (
    ApplicationWrapper
  )
);

(function () {
  if (!isStaging) return;
  const script = document.createElement('script');

  script.src =
    'https://cdnjs.cloudflare.com/ajax/libs/eruda/3.4.1/eruda.min.js';

  script.onload = () => (window as Application).eruda?.init();
  document.head.append(script);
})();
